import { render, staticRenderFns } from "./AppStatement.vue?vue&type=template&id=61c3d1f8&scoped=true&"
import script from "./AppStatement.vue?vue&type=script&lang=ts&"
export * from "./AppStatement.vue?vue&type=script&lang=ts&"
import style0 from "./AppStatement.vue?vue&type=style&index=0&id=61c3d1f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3d1f8",
  null
  
)

component.options.__file = "AppStatement.vue"
export default component.exports